// extracted by mini-css-extract-plugin
module.exports = {"ProductOptions":"styles_ProductOptions__L_6Km","active":"styles_active__mzGwn","option":"styles_option__iH8ni","text":"styles_text__WTe7F","isSelected":"styles_isSelected__sQU3m"};